module.exports = __webpack_public_path__ + "img/show_cn_text_9.275b9958.png";